<div *ngIf="isGivingDay()"  class="d-flex flex-column align-items-center text-center pb-5">
  <img ngSrc="../../giving/bundles/assets/images/triton_giving_day_2025.png"
       priority width="150" height="150" alt="Triton Giving Day 2025" />
  <p class="gray pt-3">
    Triton Giving Day is here!
    <br />
    By making a gift today, you join thousands of UC San Diego community members who are unlocking possibility together and creating a lasting impact on programs and initiatives across campus. #TritonGivingDay
  </p>
</div>
